import { Input as AntdInput } from "antd";

import type { AvE2EProps } from "@av/components/types";

import type { SearchProps as AntdSearchProps } from "antd/es/input";

type SearchProps = AntdSearchProps & AvE2EProps;

export function CustomSearch(props: SearchProps) {
  const { testIdPrefix, ...rest } = props;

  return (
    <AntdInput.Search
      allowClear
      data-testid={testIdPrefix + "-search-input"}
      style={{ width: 300 }}
      {...rest}
    />
  );
}
